import { Box, HStack, Image, Center, VStack } from '@chakra-ui/react';
import { FileStatus, TaskDocument } from '../../../models';
import { extractName, formatDate, matchIcon } from '../../../utils';
import { FilesUploader } from '../../../components';
import { NewTaskFilesUploader } from '../../../components/NewTaskFileUploader';

export const TaskDocuments = ({
  documents = [],
  taskId,
  files,
  setFiles,
}: {
  documents?: TaskDocument[];
  taskId?: number;
  setFiles: React.Dispatch<
    React.SetStateAction<
      {
        file: File;
        status: FileStatus;
      }[]
    >
  >;
  files: { file: File; status: FileStatus }[];
}) => {
  return (
    <VStack align="stretch">
      {taskId ? (
        <FilesUploader attachedId={taskId} />
      ) : (
        <NewTaskFilesUploader files={files} setFiles={setFiles} />
      )}

      {documents.map(
        ({
          id,
          documentOriginalFileName,
          downloadURL,
          teamMemberOwner,
          createdAt,
        }) => (
          <Box
            key={id}
            border="1px"
            borderRadius="md"
            borderColor="custom_gray.4"
            p="3"
            mt="3"
            cursor="pointer"
            onClick={() => window.open(downloadURL, '_blank')}
          >
            <HStack justify="space-between" w="full">
              <HStack gap="4" align="start">
                <Image
                  // TODO: get the default file image from UI/UX
                  fallbackSrc="/icons/txt.svg"
                  src={matchIcon(documentOriginalFileName)}
                  alt="file icon"
                  boxSize="8"
                />

                <VStack align="flex-start">
                  <Box fontWeight="medium" color="custom_blue.1" fontSize="lg">
                    {documentOriginalFileName}
                  </Box>

                  <HStack>
                    <Box w="5" h="5" bg="custom_blue.1" borderRadius="full">
                      {teamMemberOwner.profilePictureThumbnailURL ? (
                        <Image
                          src={teamMemberOwner.profilePictureThumbnailURL}
                          borderRadius="full"
                        />
                      ) : (
                        <Center
                          h="full"
                          color="white"
                          textTransform="capitalize"
                        >
                          {extractName(teamMemberOwner.firstName)}
                        </Center>
                      )}
                    </Box>

                    <Box color="custom_blue.1" fontSize="md">
                      {teamMemberOwner.firstName}
                    </Box>

                    <Box fontSize="xs" color="custom_gray.9">
                      {formatDate(createdAt)}
                    </Box>
                  </HStack>
                </VStack>
              </HStack>
            </HStack>
          </Box>
        )
      )}
    </VStack>
  );
};
